export default {"src":"/_next/static/media/card-users.c1945e13.svg","height":82,"width":82,"blurWidth":0,"blurHeight":0};